import CtaName from '../interfaces/ctaName';

const navigationFooterLabels: CtaName = {
  BACK: 'BACK',
  LETS_BEGIN: "LET'S BEGIN",
  GO_TO_HOMEPAGE: 'GO TO HOMEPAGE',
};

export default navigationFooterLabels;
